import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Azure AD / Entra ID authentication.
 *
 * Required env vars (set in .env / .env.production):
 *   REACT_APP_AZURE_CLIENT_ID   — Frontend SPA app registration client ID
 *   REACT_APP_AZURE_TENANT_ID   — Entra ID tenant ID
 *   REACT_APP_API_SCOPE         — Backend API scope, e.g. api://<tenant>/lisa-backend-api-dev/.default
 */

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
        else if (level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
    },
  },
};

/**
 * Scopes requested when acquiring tokens for the backend API.
 */
export const loginRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE || `api://${tenantId}/lisa-backend-api/.default`],
};

/**
 * Singleton MSAL instance — shared across the app.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
